import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'formErrorMessage', standalone: false })
export class FormErrorMessagePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(errors: any, fieldKey: string): string | null {
    if (!errors) return null;
    let errorKey = Object.keys(errors)[0];
    const field = this.translate.instant(fieldKey);
    if (errorKey === 'pattern') {
      switch (fieldKey) {
        case 'CARD_NUMBER':
          errorKey = 'cardNumInvalid';
          break;
        case 'PIN_U':
          errorKey = 'pinInvalid';
          break;
      }
    }
    const errorTemplate = this.translate.instant(`FORM_ERRORS.${errorKey}`);
    const params = { field, ...errors[errorKey] };
    return this.interpolate(errorTemplate, params);
  }
  private interpolate(template: string, params: any): string {
    return template.replace(/{{(.*?)}}/g, (_, key) => params[key.trim()] ?? '');
  }
}
